import { TaskHeaderBar } from '@repo/ccc-queue-app-lib/src/lib/TaskHeaderBar/TaskHeaderBar.tsx'
import { TaskPageLayoutUi } from '@repo/ccc-queue-app-lib/src/lib/TaskPageLayoutUi.tsx'
import { TaskPage } from '@repo/ccc-queue-app-lib/src/pages/TaskPage/TaskPage.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/tasks/$taskId')({
  component: TaskRoute,
})

function TaskRoute() {
  const { taskId } = Route.useParams()

  return (
    <TaskPageLayoutUi>
      <TaskHeaderBar />
      <TaskPage taskId={taskId} />
    </TaskPageLayoutUi>
  )
}
